<ng-container *ngIf="showPrivateLayout">
  <app-navbar (toggleSidebar)="sidebar.toggleSidebar()" ></app-navbar>
  <app-sidebar #sidebar></app-sidebar>
</ng-container>
<router-outlet />
<p-toast></p-toast>
